// import React from 'react'

// function ShippingContainer() {
//   return (
//     <div>ShippingContainer</div>
//   )
// }

// export default ShippingContainer
// import React from 'react'
// import "./TermsContainer.css"
// function TermsContainer({layout}) {
//   return (
//     <section className='terms_container'>
// {layout&&layout.TermsContainer}
//     </section>
//   )
// }

// export default TermsContainer
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

/**
 * TermsContainer.jsx
 * A single-file React component (Tailwind CSS classes) that displays
 * bilingual (Arabic + English) Terms & Conditions and provides
 * copy-to-clipboard buttons which copy each language as a single
 * continuous block of text (no extra blank lines), ready to paste.
 *
 * Props:
 *  - storeName, domain, email, companyAddress, effectiveDate
 *
 * Usage:
 *  <TermsContainer
 *    storeName="My Store"
 *    domain="mystore.com"
 *    email="info@mystore.com"
 *    companyAddress="Cairo, Egypt"
 *    effectiveDate="2025-10-09"
 *  />
 */

const defaultArabic = `سياسة الشحن
	•	يتم تجهيز وشحن الطلبات خلال 1–3 أيام عمل داخل القاهرة والجيزة، و 3–7 أيام عمل للمحافظات الأخرى.
	•	في حالة وجود أي تأخير خارج عن إرادتنا، سيتم التواصل مع العميل مباشرة.
	•	العميل يحصل على رقم تتبع للشحنة لمتابعة حالة الطلب.
`;

const defaultEnglish = `Shipping / Service Duration Policy
Orders are processed and shipped within 1–3 business days within Cairo and Giza, and 3–7 business days to other governorates.
• In the event of any delay beyond our control, the customer will be contacted directly.
• The customer will receive a shipment tracking number to track the order status.
.`;

export default function TermsContainer({
  storeName = "[Your Store Name]",
  domain = "[yourdomain.com]",
  email = "[your email address]",
  companyAddress = "[your company address]",
  effectiveDate = "[Insert Date]",
}) {
    const { currentLocal } = useSelector((state) => state.currentLocal);

  const [lang, setLang] = useState(currentLocal.language==="English"?'en':"ar"); // 'ar' | 'en' | 'both'
useEffect(() => {
setLang(currentLocal.language==="English"?'en':"ar")
}, [currentLocal])
  const buildArabic = () => {
    // replace placeholders
    return defaultArabic
      .replace(/\[اسم متجرك\]/g, storeName)
      .replace(/\[yourdomain.com\]/g, domain)
      .replace(/\[your email address\]/g, email)
      .replace(/\[أدخل التاريخ\]/g, effectiveDate)
      .replace(/\[اسم الدولة\]/g, "Egypt")
      .replace(/\[اسم المدينة أو الدولة\]/g, "[Your City or Country]");
  };

  const buildEnglish = () => {
    return defaultEnglish
      .replace(/\[Your Store Name\]/g, storeName)
      .replace(/\[yourdomain.com\]/g, domain)
      .replace(/\[your email address\]/g, email)
      .replace(/\[Insert Date\]/g, effectiveDate)
      .replace(/\[Your Country\]/g, "Egypt")
      .replace(/\[Your City or Country\]/g, "[Your City or Country]");
  };



  return (
    <div className="max-w-5xl mx-auto p-6">
      <header className="flex items-center justify-between mb-6">
        <div className="flex gap-2">
        
  

        </div>
      </header>

      <div className="flex gap-6 flex-col lg:flex-row">
        {(lang === "both" || lang === "ar") && (
          <section className="flex-1 p-4 border rounded" dir="rtl">
    
            <div className="prose prose-lg overflow-auto max-h-[60vh]">
              {/* Render Arabic as paragraphs */}
              {buildArabic().split(/\n/).map((line, i) => (
                <p key={i} style={{marginTop: i===0?0:8}}>{line}</p>
              ))}
            </div>
          </section>
        )}

        {(lang === "both" || lang === "en") && (
          <section className="flex-1 p-4 border rounded">
  

            <div className="prose prose-lg overflow-auto max-h-[60vh]">
              {buildEnglish().split(/\n/).map((line, i) => (
                <p key={i} style={{marginTop: i===0?0:8}}>{line}</p>
              ))}
            </div>
          </section>
        )}
      </div>


    </div>
  );
}
